// extracted by mini-css-extract-plugin
export default {"wrapper":"Tutorial-module__wrapper","fade-in":"Tutorial-module__fade-in","modal":"Tutorial-module__modal","buttonWrapper":"Tutorial-module__buttonWrapper"};